<template>
    <div id="apprentice">
        <!-- 导航栏 -->
        <div id="headers">
            <img src="../assets/images/img_31.png" alt="" @click="returnPage" id="returns">
            <div class="headerText">收徒分享赚更多</div>
            <div class="rule" @click="inApprenticebByLaws">细则</div>
        </div>

        <!-- 收徒情况面板 -->
        <div class="apprenticePanel">
            <div class="panel">
                <div class="tops borderB">
                    <div class="panelLefts">
                        <span>今日收徒</span>
                        <span>{{apprenticeData.t_child_count}}</span>
                    </div>
                    <div class="panelRights">
                        <span>累计收徒</span>
                        <span>{{apprenticeData.all_child_count}}</span>
                    </div>
                </div>
                <div class="bottoms">
                    <div class="panelLefts">
                        <span>今日收益</span>
                        <span>{{apprenticeData.t_sum_fathermoney}}<i>元</i></span>
                    </div>
                    <div class="panelRights">
                        <span>累计收益</span>
                        <span>{{apprenticeData.all_sum_fathermoney}}<i>元</i></span>
                    </div>
                </div>
            </div>
        </div>

        <!-- 分享 -->
        <div class="share">
            <div class="shareTops">
                <div>邀请一位好友</div>
                <div>提成做多可得<div class="icons">10</div>元</div>
                <div>邀请数量无限制哦~</div>
            </div>
            <div class="shareBottoms">
                <div class="shareTit">多种方式 分享即收徒</div>
                <div class="shareIcon">
                    <img @click="wx_pyq" src="../assets/images/img_07.png" alt="">
                    <img @click="wx_friend" src="../assets/images/img_06.png" alt="">
                </div>
                <div class="copyLink" :data-clipboard-text=" webServerDomain + '/#/share?inviteCode='+apprenticeData.invite_code" @click="copyLinks">复制邀请链接</div>
                <div class="erweima" @click="inErweimaShare">专属二维码</div>
            </div>
        </div>

        <SlowPop :slows="slows"></SlowPop>
    </div>
</template>

<script>
    import SlowPop from '../components/slowPop.vue'
    import Clipboard from 'clipboard'
    export default {
        components:{
            SlowPop
        },
        data() {
            return {
                slows:false,
                apprenticeData:{},
                webServerDomain: ''
            }
        },
        mounted() {
            this.init();
            this.webServerDomain = localStorage.getItem('webServerDomain');
        },
        methods: {
            init(){
                this.$loading(true);
                let datas = {}
                this.$http.GETS('amway/masterHome',datas,(res)=>{
                    this.apprenticeData = res.data
                    this.$loading(false);
                    console.log(this.apprenticeData);
                });
            },
            returnPage:function(){
                this.$router.go(-1);
            },
            // 进入 您的分享二维码
            inErweimaShare:function(){
                this.$router.push('/incomeDetails/erweimaShare');
            },
            // 进入 收徒分享细则
            inApprenticebByLaws:function(){
                this.$router.push('/apprentice/apprenticebByLaws');
            },
            // 分享到朋友圈
            wx_pyq() {
                location.href = this.apprenticeData.share.wechat;
            },
            // 分享给好友
            wx_friend() {
                location.href = this.apprenticeData.share.wechat_message;
            },

            // 复制邀请链接
            copyLinks:function(){
                let _this = this
                var clipboard = new Clipboard('.copyLink')
                clipboard.on('success', e => {
                    if(!this.slows){
                        this.slows = true;
                        setTimeout(()=>{
                            this.slows = false;
                        },2000)
                    }
                    // 释放内存
                    clipboard.destroy()
                })
                clipboard.on('error', e => {
                    // 不支持复制
                    this.$toast('该浏览器不支持自动复制')
                    // 释放内存
                    clipboard.destroy()
                })
            },
        },
    }
</script>

<style lang="less" scoped>
    #apprentice{
        // 导航栏
        #headers{
            width: 375px;
            height: 45px;
            background: linear-gradient(to right,#EB3F47,#E50113);
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            #returns{
                width: 11px;
                height: 18px;
                position: absolute;
                left: 15px;
                padding: 0 3px;
            }
            .headerText{
                font-size: 15px;
                color: #FFFFFF;
            }
            .rule{
                font-size:15px;
                color:rgba(255,255,255,1);
                position: absolute;
                right: 25px;
            }
        }
        // 收徒情况面板
        .apprenticePanel{
            width: 375px;
            height: 80px;
            padding-top: 8px;
            background:linear-gradient(313deg,rgba(229,1,19,1) 0%,rgba(235,63,71,1) 100%);
            .panel{
                width:315px;
                height:160px;
                background:rgba(255,255,255,1);
                box-shadow:0px 5px 10px 0px rgba(0,0,0,0.05);
                border-radius:5px;
                border:1px solid rgba(222,222,222,.5);
                margin: 0 15px;
                padding: 0 15px;
                .borderB{
                    border-bottom: 1px solid rgba(229, 229, 229, .5);
                }
                .tops,.bottoms{
                    height: 50%;
                    padding: 15px 0;
                    box-sizing: border-box;
                    display: flex;
                    .panelLefts{
                        width: 50%;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: space-between;
                        span{
                            &:nth-of-type(1){
                                font-size:13px;
                                font-weight:400;
                                color:rgba(21,21,21,.5);
                                line-height:18px;
                            }
                            &:nth-of-type(2){
                                font-size:25px;
                                font-family: "Qds";
                                color:rgba(229,1,19,1);
                                font-weight: bold;
                                margin-top: 5px;
                                i{
                                    font-style: normal;
                                    font-size: 13px;
                                }
                            }
                        }
                    }
                    .panelRights{
                        width: 50%;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: space-between;    
                        span{
                            &:nth-of-type(1){
                                font-size:13px;
                                font-weight:400;
                                color:rgba(21,21,21,.5);
                                line-height:18px;
                            }
                            &:nth-of-type(2){
                                font-size:25px;
                                font-family: "Qds";
                                color: rgba(21,21,21,1);
                                font-weight: bold;
                                margin-top: 5px;
                                i{
                                    font-style: normal;
                                    font-size: 13px;
                                }
                            }
                        }                    
                    }
                }
            }
        }
        // 分享
        .share{
            width: 355px;
            height: 419px;
            background-image: url('../assets/images/img_17.png');
            background-repeat: no-repeat;
            background-size: 100% 100%;
            margin: 90px 10px 0;
            // padding-bottom: 15px;
            position: relative;
            .shareTops{
                font-size:15px;
                font-family:Arial, Helvetica, sans-serif;
                color:rgba(255,255,255,1);
                line-height:25px;
                position: absolute;
                left: 24px;
                top: 52px;
                &>div{
                    display: flex;
                    align-items: center;
                    .icons{
                        width:27px;
                        height:27px;
                        background:rgba(255,255,255,1);
                        border-radius: 50%;
                        font-size:18px;
                        color:rgba(229,1,19,1);
                        font-weight: bold;
                        font-family:Arial, Helvetica, sans-serif;
                        margin: 0 5px;
                        line-height:normal;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }
                }
            }
            .shareBottoms{
                width: 335px;
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
                top: 183px;
                .shareTit{
                    font-size:15px;
                    font-family:Arial, Helvetica, sans-serif;
                    color:rgba(21,21,21,1);
                    line-height:18px;
                    font-weight: 600;
                    text-align: center;
                }
                .shareIcon{
                    width: 100%;
                    // display: flex;
                    // justify-content: flex-start;
                    text-align: center;
                    // align-items: center;
                    margin-top: 25px;
                    img{
                        width: 35px;
                        height: 35px;
                    }
                    img:last-child {
                        margin-left: 50px;
                    }
                }
                .copyLink,.erweima{
                    width:275px;
                    height:40px;
                    border-radius:25px;
                    border:1px solid rgba(229,229,229,1);
                    font-size:15px;
                    font-weight:bold;
                    color:rgba(21,21,21,1);
                    margin: 0 auto;
                    margin-top: 20px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
            }
        }
    }
</style>